import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ai-chat/FullScreenInterface.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewNavBar"] */ "/vercel/path0/src/components/common/NewNavBar.tsx");
